import dayjs from 'dayjs';

export function formatDate(date: string | Date, format = 'DD/MM/YYYY') {
  return dayjs(date).format(format);
}

export function formatDateTime(date: string | Date) {
  return dayjs(date).format('DD/MM/YYYY HH:mm:ss');
}

export function formatNumber(value: number, decimals = 0) {
  return new Intl.NumberFormat('vi-VN', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value);
}

/** Số đo telemetry / ngưỡng hiển thị UI — mặc định 2 chữ số thập phân. */
export const MEASURE_DISPLAY_DECIMALS = 2;

export function formatMeasureNumber(
  value: number,
  decimals = MEASURE_DISPLAY_DECIMALS,
): string {
  if (!Number.isFinite(value)) return '—';
  return formatNumber(value, decimals);
}

export function formatMeasureWithUnit(
  value: number,
  unit?: string,
  decimals = MEASURE_DISPLAY_DECIMALS,
): string {
  const core = formatMeasureNumber(value, decimals);
  const u = unit?.trim();
  return u ? `${core} ${u}` : core;
}

export function formatPercent(value: number, decimals = 1) {
  return `${value.toFixed(decimals)}%`;
}

export function formatFileSize(bytes: number) {
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  let index = 0;
  let size = bytes;
  while (size >= 1024 && index < units.length - 1) {
    size /= 1024;
    index++;
  }
  return `${size.toFixed(1)} ${units[index]}`;
}
